import { EMAIL_VALIDATION_PATTERN } from "../../views/authentication/constants";

export const validateEmail = ({ email, trans, isSuggestEmailDomain }) => {
  if (!email) {
    return trans("Email is required.");
  }
  if (!isValidEmailFormat(email)) {
    return trans("This is not a valid email.");
  }
  if (isSuggestEmailDomain) {
    // eslint-disable-next-line no-console
    console.log("suggesting email domain");
  }
  return null;
};

const isValidEmailFormat = email => {
  const regex = EMAIL_VALIDATION_PATTERN;
  return new RegExp(regex).test(email);
};
